import Box from "@mui/material/Box";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { ExchangeGroup } from "@redotech/redo-model/team";
import { Button, ButtonSize, ButtonTheme } from "@redotech/redo-web/button";
import { CurrencyContext } from "@redotech/redo-web/currency";
import { memo, useContext } from "react";
import * as advancedExchange from "./advanced-exchange.module.css";
import { ExchangeProduct } from "./variant-bubbles";

export const ExchangeItem = memo(function ExchangeItem({
  setItemDetailsModalOpen,
  setSelectedProduct,
  product,
  exchangeGroup,
  chooseButtonPending = false,
}: {
  setItemDetailsModalOpen: (open: boolean) => void;
  setSelectedProduct: (product: ExchangeProduct) => void;
  product: ExchangeProduct;
  exchangeGroup?: ExchangeGroup;
  chooseButtonPending?: boolean;
}) {
  const { formatCurrency } = useContext(CurrencyContext);

  const openModal = () => {
    setSelectedProduct(product);
    setItemDetailsModalOpen(true);
  };

  return (
    <Box className={advancedExchange.exchangeItem}>
      <CardMedia
        alt="product image"
        className={advancedExchange.exchangeItemImage}
        component="img"
        image={product.image}
        onClick={openModal}
      />
      <div className={advancedExchange.exchangeItemContent}>
        <Typography
          color="text.secondary"
          gutterBottom
          onClick={openModal}
          sx={{
            paddingTop: "10px",
            cursor: "pointer",
            overflow: "hidden",
            whiteSpace: "wrap",
            textOverflow: "ellipsis",
          }}
          variant="body2"
        >
          {product.title}
        </Typography>
        <div>
          <Typography
            sx={{
              paddingTop: "5px",
              visibility:
                exchangeGroup?.priceDifference === "ignore"
                  ? "hidden"
                  : "visible",
            }}
            variant="body1"
          >
            {formatCurrency(parseFloat(product.price))}
          </Typography>
          <Button
            className={advancedExchange.exchangeItemButton}
            onClick={async () => {
              openModal();
            }}
            pending={chooseButtonPending}
            size={ButtonSize.MEDIUM}
            theme={ButtonTheme.OUTLINED}
          >
            Choose
          </Button>
        </div>
      </div>
    </Box>
  );
});
